module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av60-c226a5fd866066e606a306731fe09bf0.jpg";